// extracted by mini-css-extract-plugin
module.exports =  {"label":"_7a3fb80146--label--XI5A0","pros":"_7a3fb80146--pros--QaXPQ","cons":"_7a3fb80146--cons--I13Sb"};